import { DocsBreadcrumb } from '@/business-components/docs-breadcrumb/DocsBreadcrumb';
import { NavbarGroup } from '@/business-components/navbar-group/NavbarGroup';
import { NavbarGroupType } from '@/business-components/navbar-group/type/NavbarGroupTypeLevel';
import { SidebarTree } from '@/business-components/sidebar-tree/SidebarTree';
import { SpecialFileMenu } from '@/business-components/special-file-menu/SpecialFileMenu';
import { useGenerateBreadcrumbList } from '@/hooks/useGenerateBreadcrumbList';
import usePersistFn from '@/hooks/usePersistFn';
import { useDocsDataModelStore } from '@/models/docs-data/docsData';
import { GlobalClassName } from '@/shared/constant/GlobalClassName';
import { useNavigation } from '@remix-run/react';
import { Button, Drawer } from 'aui';
import { FoxIconMenu01 } from 'aui-biz-icons';
import clsx from 'clsx';
import React from 'react';
import { useDocsLayoutStore } from '../../store/docsLayoutStore';
import { BrandLogoArea } from '../brand-logo-area/BrandLogoArea';
import { useLevelNavbarGroup } from '../navbar-content/hooks/useLevelNavbarGroup';
import styles from './MobileHeaderContent.module.css';

export type MobileHeaderContentProps = {
  className?: string;
};

export function MobileHeaderContent(props: MobileHeaderContentProps) {
  const { className } = props;

  const navigation = useDocsDataModelStore((x) => x.navigation);
  const { secondLevelNavbarGroup, thirdLevelNavbarGroup } = useLevelNavbarGroup(navigation);
  const openDrawer = useDocsLayoutStore((x) => x.openDrawer);
  const setOpenDrawer = useDocsLayoutStore((x) => x.setOpenDrawer);
  const breadcrumbList = useGenerateBreadcrumbList();
  const hiddenDrawer = usePersistFn(() => {
    setOpenDrawer(false);
  });

  const { state: navigationState } = useNavigation();
  React.useEffect(() => {
    if (navigationState === 'idle') {
      hiddenDrawer();
    }
  }, [navigationState, hiddenDrawer]);

  const searchSubfix = secondLevelNavbarGroup?.type === NavbarGroupType.Select && (
    <NavbarGroup {...secondLevelNavbarGroup} className="mt-2.5" onClick={hiddenDrawer} />
  );
  const treeListPrefix = (
    <>
      {secondLevelNavbarGroup && secondLevelNavbarGroup.type !== NavbarGroupType.Select && (
        <NavbarGroup
          {...secondLevelNavbarGroup}
          className={clsx(GlobalClassName.HeaderSecondlyNavbar, 'mb-2.5 pr-2')}
          onClick={hiddenDrawer}
        />
      )}
      {thirdLevelNavbarGroup && (
        <NavbarGroup
          {...thirdLevelNavbarGroup}
          className={clsx(GlobalClassName.HeaderTertiaryNavbar, 'pr-2')}
          onClick={hiddenDrawer}
        />
      )}

      {(secondLevelNavbarGroup || thirdLevelNavbarGroup) && (
        <div className="my-5 border-b border-solid border-color-split" />
      )}
    </>
  );

  return (
    <div className={clsx('sticky top-[57px] z-20 flex w-full os:hidden', className)}>
      <div className="flex w-full items-center gap-2 px-3 py-2">
        <Button
          aria-label="open sidebar drawer"
          type="text"
          icon={<FoxIconMenu01 />}
          onClick={() => setOpenDrawer(true)}
        />

        <DocsBreadcrumb
          className="w-0 flex-1"
          value={breadcrumbList}
          rightNode={<SpecialFileMenu />}
        />
      </div>

      <Drawer
        className={clsx('os:hidden', styles.drawer)}
        placement="left"
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
        title={<BrandLogoArea onlyShowBrand onVersionSelectClick={hiddenDrawer} />}
      >
        <SidebarTree
          className="h-full"
          searchSubfix={searchSubfix}
          treeListPrefix={treeListPrefix}
        />
      </Drawer>
    </div>
  );
}
